import React, { forwardRef } from 'react'
import { FieldProps, useFocusRing, LabelBlock, COLORS } from './WooNotesControlsCommon'

export const WooNotesTextInput = forwardRef<HTMLInputElement, FieldProps>(({ label, helperText, errorText, raised, style, ...props }, ref) => {
  const ring = useFocusRing()

  return (
    <LabelBlock label={label} helperText={helperText} errorText={errorText}>
      <input
        ref={ref}
        className="woo-notes-text-inputx"
        {...props}
        {...ring}
        style={{
          // ['--input-bg' as any]: COLORS.bg,
          // ['--input-text' as any]: COLORS.text,
          width: '100%',
          padding: '12px 14px',
          borderRadius: 14,
          border: `2px solid ${errorText ? COLORS.danger : COLORS.dark}`,
          background: COLORS.bg,
          color: COLORS.text,
          outline: 'none',
          fontSize: 16,
          fontWeight: 700,

          boxShadow:
            raised !== false
              ? ring.focused
                ? `0 0 0 5px ${COLORS.ring}, 0 6px 0 ${COLORS.dark}`
                : `0 6px 0 ${COLORS.dark}, 0 10px 18px rgba(14, 74, 44, 0.10)`
              : undefined,

          transition: 'box-shadow 120ms ease, transform 120ms ease, border 120ms ease',
          ...style,
        }}
        placeholder={props.placeholder}
        onKeyDown={e => {
          props.onKeyDown?.(e)
        }}
      />
    </LabelBlock>
  )
})

WooNotesTextInput.displayName = 'WooNotesTextInput'
